/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { UpdateProfileProps } from "./components";
const is = require("is_js");

const SERVICE_NAME = "ProfilePageService";
const log: any = LoggerModule.getInstance();

export class ProfilePageService {
  private static instance: ProfilePageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): ProfilePageService {
    if (!ProfilePageService.instance) {
      ProfilePageService.instance = new ProfilePageService(props);
    }
    return ProfilePageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //ProfileCard Props
    compProps = await agent.getProfileCardProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async updateProfile(args: UpdateProfileProps) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.getUpdateProfile(args);
  }
}
